import { render, staticRenderFns } from "./Message.page.vue?vue&type=template&id=6edabcb5&"
import script from "./Message.page.vue?vue&type=script&lang=js&"
export * from "./Message.page.vue?vue&type=script&lang=js&"
import style0 from "./Message.page.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports